import { Suspense, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { Spinner } from '@/components/ui'
import { usePermission } from '@/hooks/usePermission'

/** Redirects users without `permission` home; wraps the lazy page in Suspense. */
export function SurfaceGuard({ permission, children }: { permission: string; children: ReactNode }) {
  const allowed = usePermission(permission)
  if (!allowed) return <Navigate to="/" replace />
  return (
    <Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner /></div>}>
      {children}
    </Suspense>
  )
}
